import React from 'react'
import { default as MSelect} from 'react-multi-select-component';

import { multiselectOverrideStrings } from '../lib/constants';

export interface Option {
  value: any;
  label: string;
  key?: string;
  disabled?: boolean;
}

export interface ISelectProps {
  options: Option[];
  value: Option[];
  focusSearchOnOpen?: boolean;
  onChange?: (param: any) => any;
  valueRenderer?: (selected: Option[], options: Option[]) => string;
  ItemRenderer?: Function;
  ArrowRenderer?: ({ expanded: boolean }: any) => void;
  selectAllLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  disableSearch?: boolean;
  shouldToggleOnHover?: boolean;
  hasSelectAll?: boolean;
  filterOptions?: (options: Option[], filter: string) => Option[];
  overrideStrings?: { [key: string]: string };
  labelledBy?: string;
  className?: string;
  onMenuToggle?: (param: any) => any;
  ClearIcon?: string | Function;
  debounceDuration?: number;
  ClearSelectedIcon?: string | Function;
  maxResult?: number;
}

const defaultMaxResult = 100

export default class Multiselect extends React.Component<ISelectProps> {
    constructor(props: ISelectProps) {
        super(props);

        this.selectFilter = this.selectFilter.bind(this);
    }

    selectFilter (options: any[], filter: string) {
        let maxResult = this.props.maxResult || defaultMaxResult;

        if(!filter) {
            if(options.length > maxResult) {
                const searchHeader: any[] = [{ label: 'Använd sök för att visa valen.', header: true, disabled: true}];

                return searchHeader;//.concat(options.slice(0, 20));
            }
            else {
                return options;
            }
        }
        const re = new RegExp(filter, "i");
        const searchResult = options.filter(({label}) => label && label.match(re));
        const numOfResults = searchResult.length;

        const searchHeader: any[] = numOfResults > 0 ?
                                        numOfResults > maxResult ?
                                            [{label: `Visar ${maxResult} av ${numOfResults} sökresultat`, header: true, disabled: true}]
                                        : [{label: `${numOfResults} sökresultat`, header: true, disabled: true}]
                                    : [{ label: 'Inga sökresultat', header: true, disabled: true}];

        return searchHeader.concat(searchResult.slice(0, maxResult));
    }


    render() {
        return (
            <MSelect 
                className='multi-select-component'
                filterOptions={this.selectFilter}
                hasSelectAll={false}
                labelledBy={"Select"}
                overrideStrings={multiselectOverrideStrings}
                valueRenderer={(selected) => { 
                    var str = selected.map(sel => sel.label).join(', ')
                    if(str.length > 50)
                        str = str.substring(0, 47) + '...';

                    return str;
                }} 
                ItemRenderer={({
                    checked,
                    option,
                    onClick,
                    disabled,
                }: {
                    checked: boolean,
                    option: {
                        value: any;
                        label: string;
                        key?: string;
                        disabled?: boolean;
                        header?: boolean;
                    },
                    disabled?: boolean,
                    onClick(event: React.ChangeEvent<HTMLInputElement>) : void}) => {
                        if(option.header) {
                            return (<div className={'multiselect-dropdown-header'}>
                                <span>{option.label}</span>
                            </div>);
                        }
                        return (<div className={`item-renderer ${disabled ? " disabled" : ""}`} >
                            <input
                                type="checkbox"
                                onChange={onClick}
                                checked={checked}
                                tabIndex={-1}
                                disabled={disabled}
                            />
                            <span  style={{paddingLeft: '5px'}}>{option.label}</span>
                        </div>);
                    }
                }
                {...this.props}
            />
        );
    }
}